export const Status = Object.freeze({
  ACTIVE: 'active',
  PENDING: 'pending',
});
